import { query } from '@/gql/apolloClient';
import {
  GET_EMPLOYER_ONBOARDING_STATUS,
  IS_EVENT_SCHEDULED_FOR_USER,
} from '@/gql/queries/onboarding.gql';
import { GET_WIZARDS_BY_DESTINATION } from '@/gql/queries/wizard.gql';
import { GET_COMPANY_SUBSCRIPTIONS_QUERY } from '@/gql/queries/billing.gql';

export const getEmployerOnboardingStatus = (data, options = {}) =>
  query(GET_EMPLOYER_ONBOARDING_STATUS, { data }, 'findOnboarding', options);

export const getEventScheduledStatus = (data, options = {}) =>
  query(IS_EVENT_SCHEDULED_FOR_USER, data, 'isEventScheduledForUser', options);

export const getWizardsByDestination = (filter, options = {}) =>
  query(GET_WIZARDS_BY_DESTINATION, { filter }, 'wizards', options);

export const getCompanySubscriptions = (data, options = {}) =>
  query(
    GET_COMPANY_SUBSCRIPTIONS_QUERY,
    { data },
    'companySubscriptions',
    options
  );
